export default "__VITE_ASSET__uBnGiLKd__"